import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { withRouter } from "react-router-dom";
import { features } from "../../../Shared/features";
import { WiseConfig } from "../../../Shared/features/WiseConfig";
import { trackCollectionSearch } from "./library/tracking";
import { searchParams } from "../../../Shared/components/Collection/CollectionOverview/CollectionOverviewUtils";
class CollectionSearchBar extends React.Component {
    render() {
        const { query } = this.state;
        const collectionConfig = features().collection;
        const search = ()=>{
            trackCollectionSearch(query);
            collectionConfig == 'off' || collectionConfig.isInSoftLaunch ? window.open(`${WiseConfig().BaseUrl}/wise-apps/opac/${WiseConfig().LibraryId}/catalog/search?qs=${query}`) : this.props.history.push({
                pathname: collectionConfig.route,
                search: searchParams({
                    query
                })
            });
        };
        return /*#__PURE__*/ _jsxs("div", {
            className: "form form--search",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "form__group",
                    children: /*#__PURE__*/ _jsxs("label", {
                        htmlFor: "collection-search",
                        className: "form__label",
                        children: [
                            "Wat wil je lezen, luisteren of kijken?",
                            /*#__PURE__*/ _jsx("span", {
                                className: "sr-text",
                                children: "(externe link)"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "search__input-container",
                    children: [
                        /*#__PURE__*/ _jsx("input", {
                            id: "collection-search",
                            className: "form__input search__input",
                            type: "text",
                            onChange: (e)=>this.setState({
                                    ...this.state,
                                    query: e.currentTarget.value
                                }),
                            value: query,
                            onKeyPress: (e)=>e.key == "Enter" ? search() : {},
                            placeholder: "Titel, auteur of ISBN",
                            autoComplete: "on"
                        }),
                        /*#__PURE__*/ _jsxs("button", {
                            type: "button",
                            className: "search__button",
                            onClick: search,
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "sr-text",
                                    children: "Zoeken"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "icon icon-search",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            query: ""
        };
    }
}
export default withRouter(CollectionSearchBar);
